
import * as React from 'react';
import { Link } from 'react-router-dom';
import * as navigate from 'app/area/shared/navigation';

interface FactLinkProps {
  classNames?: string;
  section?: number;
  url?: string;
  children?: React.ReactNode;
  id?: string;
  urlOpenNew?: boolean;
}

export const FactLink: React.FC<FactLinkProps> = ({ id, classNames = '', section, children, url, urlOpenNew }) => {
  const className = `${classNames} fact-link`;
  const linkTo = section || url ? navigate.toSectionURL(section, url) : undefined;

  return linkTo ? (
    <Link id={id} className={className} to={linkTo} target={urlOpenNew && '_blank'}>
      {children}
    </Link>
  ) : (
    <div className={className}>{children}</div>
  );
};
